import { render, staticRenderFns } from "./ManifestoComponent.vue?vue&type=template&id=ea9331e6&"
import script from "./ManifestoComponent.vue?vue&type=script&lang=js&"
export * from "./ManifestoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports